/**
 * API методы для работы с кампаниями: CRUD операции, запуск/пауза/отмена
 */
import { apiClient } from './client';
import { CampaignDTO } from './types';

export const campaignsApi = {
  list: async (): Promise<{ campaigns: CampaignDTO[] }> => {
    const response = await apiClient.get('/campaigns');
    return response.data;
  },

  getById: async (id: string): Promise<CampaignDTO> => {
    const response = await apiClient.get(`/campaigns/${id}`);
    return response.data;
  },

  create: async (data: any): Promise<CampaignDTO> => {
    const response = await apiClient.post('/campaigns', data);
    return response.data;
  },

  update: async (id: string, data: any): Promise<CampaignDTO> => {
    const response = await apiClient.put(`/campaigns/${id}`, data);
    return response.data;
  },

  start: async (id: string): Promise<void> => {
    await apiClient.post(`/campaigns/${id}/start`);
  },

  pause: async (id: string): Promise<void> => {
    await apiClient.post(`/campaigns/${id}/pause`);
  },

  cancel: async (id: string): Promise<void> => {
    await apiClient.post(`/campaigns/${id}/cancel`);
  },
};

